var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDataAvailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 410.209,
    height: 283,
    viewBox: "0 0 410.209 283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6354",
    "data-name": "Path 6354",
    d: "M805.455,1024.688l.27.58a2.8,2.8,0,0,0,1.7,1.488l.689.216.369-2.585a4.713,4.713,0,0,1,2.079-3.275l1.895-1.244a12.467,12.467,0,0,1,6.844-2.046h0a4.1,4.1,0,0,1,4.1,4.1v10.168a6.7,6.7,0,0,1-6.695,6.695h-.019a1.828,1.828,0,0,0-1.825,1.823v5.725a4.321,4.321,0,0,1-4.421,4.577c-2.879.135-8.291-2.49-8.291-5.339l2.685-15.627a3.031,3.031,0,0,1-2.685-2.968,2.62,2.62,0,0,1,2.111-2.86A1.041,1.041,0,0,1,805.455,1024.688Z",
    transform: "translate(-802.143 -1017.822)",
    fill: "#f79f7b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4806",
    "data-name": "Group 4806",
    transform: "translate(-18434.572 312.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4736",
    "data-name": "Group 4736",
    transform: "translate(18434.572 -312.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sofa",
    transform: "translate(66.469 117.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4685",
    "data-name": "Group 4685",
    transform: "translate(0 39.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_862",
    "data-name": "Rectangle 862",
    d: "M9.524,0H27.8a9.524,9.524,0,0,1,9.524,9.524V72.233a0,0,0,0,1,0,0h0A37.326,37.326,0,0,1,0,34.907V9.524A9.524,9.524,0,0,1,9.524,0Z",
    fill: "#dd9f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_863",
    "data-name": "Rectangle 863",
    d: "M10.587,0H28.22A10.587,10.587,0,0,1,38.807,10.587V33.426A38.807,38.807,0,0,1,0,72.233H0a0,0,0,0,1,0,0V10.587A10.587,10.587,0,0,1,10.587,0Z",
    transform: "translate(275.635)",
    fill: "#dd9f64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4688",
    "data-name": "Group 4688",
    transform: "translate(23.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4686",
    "data-name": "Group 4686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    d: "M92.164,0h83.2A92.164,92.164,0,0,1,267.53,92.164v19.723a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V92.164A92.164,92.164,0,0,1,92.164,0Z",
    fill: "#f4ca82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    d: "M23.382,0H244.148A23.382,23.382,0,0,1,267.53,23.382v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A23.382,23.382,0,0,1,23.382,0Z",
    transform: "translate(0 87.79)",
    fill: "#dd9f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6339",
    "data-name": "Path 6339",
    d: "M986.174,1453.488H741.418a11.387,11.387,0,0,1-11.387-11.387h267.53A11.388,11.388,0,0,1,986.174,1453.488Z",
    transform: "translate(-730.031 -1330.213)",
    fill: "#f4ca82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4687",
    "data-name": "Group 4687",
    transform: "translate(3.328 123.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6340",
    "data-name": "Path 6340",
    d: "M747.165,1515.2h-6.991l16.742-38.4h6.991Z",
    transform: "translate(-740.174 -1476.803)",
    fill: "#4d5463"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6341",
    "data-name": "Path 6341",
    d: "M1479.576,1515.2h6.991l-16.742-38.4h-6.991Z",
    transform: "translate(-1225.695 -1476.803)",
    fill: "#4d5463"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "woman2",
    transform: "translate(64.421 77.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4690",
    "data-name": "Group 4690",
    transform: "translate(103.17 127.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6342",
    "data-name": "Path 6342",
    d: "M1284.282,1556.274a13.341,13.341,0,0,0,7.911-.852,4.979,4.979,0,0,1,4.5,0l14.358,7.4a3.812,3.812,0,0,1,2,3.405v1.982H1282.44a2.74,2.74,0,0,1-2.565-3.306l1.085-6.117A2.955,2.955,0,0,1,1284.282,1556.274Z",
    transform: "translate(-1177.236 -1492.606)",
    fill: "#0d2e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6343",
    "data-name": "Path 6343",
    d: "M997.566,1511.7l-6.539,18.057-9.937-.48,4.98-17.576Z",
    transform: "translate(-976.527 -1463.59)",
    fill: "#f79f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6344",
    "data-name": "Path 6344",
    d: "M967.5,1561.748l3.036-5.627a1.831,1.831,0,0,1,2.009-.917l3.221.717a4.637,4.637,0,0,0,2.481-.129l3.734-1.251a2.354,2.354,0,0,1,2.3.46l13.191,11.545a3.681,3.681,0,0,1,1.258,2.772l-.756,1.863-28.637-5.664A2.581,2.581,0,0,1,967.5,1561.748Z",
    transform: "translate(-967.185 -1492.293)",
    fill: "#0d2e4e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4689",
    "data-name": "Group 4689",
    transform: "translate(100.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6345",
    "data-name": "Path 6345",
    d: "M1273.477,1365.1l20.277,4.88,29.048,3.415a1.8,1.8,0,0,1,1.263,2.825c-1.18,1.62-3.7,3.2-9.069,1.971l-22.585,6.544a5.419,5.419,0,0,1-4.761-.87h0a5.418,5.418,0,0,1-2.108-3.532l-.262-1.743-12.606-2.6Z",
    transform: "translate(-1272.673 -1365.096)",
    fill: "#f79f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6346",
    "data-name": "Path 6346",
    d: "M1310.478,1399.45a.3.3,0,0,1-.224-.5l2.776-3.148a.3.3,0,1,1,.448.395l-2.776,3.148A.3.3,0,0,1,1310.478,1399.45Z",
    transform: "translate(-1297.872 -1385.661)",
    fill: "#c05656"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4691",
    "data-name": "Group 4691",
    transform: "translate(29.013 95.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6347",
    "data-name": "Path 6347",
    d: "M996.922,1367.4l-8.916,48.432a1.184,1.184,0,0,0,1.153,1.452h13.184a1.183,1.183,0,0,0,1.079-.7l22.344-49.558Z",
    transform: "translate(-906.995 -1334.887)",
    fill: "#0d2e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6348",
    "data-name": "Path 6348",
    d: "M748.67,1269.085s-27.094,44,21.911,40.173l61.745-2.806,81.2,6.422a1.872,1.872,0,0,0,2.071-1.723l.879-11.91a1.872,1.872,0,0,0-1.431-1.958L843.71,1280.2q-1.5-.36-3.032-.58l-59.807-10.539Z",
    transform: "translate(-741.199 -1269.085)",
    fill: "#0d2e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6349",
    "data-name": "Path 6349",
    d: "M1084.353,1338.974l-.3-.129c.056-.132,5.509-13.257-5.521-19.212l.156-.289C1089.982,1325.442,1084.411,1338.839,1084.353,1338.974Z",
    transform: "translate(-967.836 -1302.851)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4700",
    "data-name": "Group 4700",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4696",
    "data-name": "Group 4696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6350",
    "data-name": "Path 6350",
    d: "M658.136,1053.786a26.611,26.611,0,0,1-4.47-8.74c-1.1-3.791-1.353-8.006.322-11.58,1.91-4.078,6.083-6.876,7.506-11.148,1.193-3.582.38-7.98,2.908-10.785,4.122-4.573,13.128-.685,17.088-5.4,2.948-3.51.909-9.533,4.023-12.9,2.94-3.176,8.519-1.906,11.951-4.542,2.664-2.046,3.281-5.852,5.558-8.322,3.091-3.352,8.279-2.524,12.647-1.219,5.125,1.532,6.565,3.831,7.3,6.221a16.734,16.734,0,0,0,4.393,7.291,16.564,16.564,0,0,1,4.424,8c1,4.029.845,8.243.655,12.39-.312,6.807-.756,13.826-3.782,19.931-3.289,6.634-9.26,11.465-15.052,16.079-4.935,3.931-9.9,7.883-15.43,10.922s-11.7,5.149-18.014,5.1A28.643,28.643,0,0,1,658.136,1053.786Z",
    transform: "translate(-652.785 -978.017)",
    fill: "#0d2e4e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4692",
    "data-name": "Group 4692",
    transform: "translate(12.034 38.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6351",
    "data-name": "Path 6351",
    d: "M746.108,1151.991l3.473-16.516,17.174-9.281a1.24,1.24,0,0,0,.582-1.507,50.256,50.256,0,0,0-20.817-25.128,32.88,32.88,0,0,0-25.428-3.681c-10.359,2.7-24.966,10.417-31.59,32.267a1.018,1.018,0,0,0,.631,1.257l16.811,5.152,4.46,16.781Z",
    transform: "translate(-689.457 -1094.8)",
    fill: "#d45e70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4695",
    "data-name": "Group 4695",
    transform: "translate(39.429 13.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4694",
    "data-name": "Group 4694",
    transform: "translate(9.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6352",
    "data-name": "Path 6352",
    d: "M805.455,1024.688l.27.58a2.8,2.8,0,0,0,1.7,1.488l.689.216.369-2.585a4.713,4.713,0,0,1,2.079-3.275l1.895-1.244a12.467,12.467,0,0,1,6.844-2.046h0a4.1,4.1,0,0,1,4.1,4.1v10.168a6.7,6.7,0,0,1-6.695,6.695h-.019a1.828,1.828,0,0,0-1.825,1.823v5.725a4.321,4.321,0,0,1-4.421,4.577c-2.879.135-8.291-2.49-8.291-5.339l2.685-15.627a3.031,3.031,0,0,1-2.685-2.968,2.62,2.62,0,0,1,2.111-2.86A1.041,1.041,0,0,1,805.455,1024.688Z",
    transform: "translate(-802.143 -1017.822)",
    fill: "#f79f7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4693",
    "data-name": "Group 4693",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6353",
    "data-name": "Path 6353",
    d: "M834.676,1076a9.224,9.224,0,0,1-5.01-2.908c-.351-.408-.878-.08-.856.457.1,2.359,2.721,5.684,6.518,6.274Z",
    transform: "translate(-820.059 -1054.829)",
    fill: "#c05656"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6355",
    "data-name": "Path 6355",
    d: "M801.754,1098.794s-6.286,9.9-28.814-1.549C772.94,1097.245,787.347,1090.341,801.754,1098.794Z",
    transform: "translate(-772.94 -1069.398)",
    fill: "#f79f7b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6356",
    "data-name": "Path 6356",
    d: "M816.33,1001.522a4.173,4.173,0,0,0,6.453,3.108c1.093-.721,2.008-2.01,3.315-1.928,1.25.078,2.212,1.444,3.457,1.31,1.308-.141,1.872-1.781,3.031-2.4,1.583-.85,3.5.476,5.287.251a3.639,3.639,0,0,0,2.949-3.128,5.225,5.225,0,0,0-1.518-4.2,9.512,9.512,0,0,0-3.945-2.317,16.3,16.3,0,0,0-18.244,5.772,5.5,5.5,0,0,0-1.058,2.086,2.4,2.4,0,0,0,.552,2.191",
    transform: "translate(-762.439 -987)",
    fill: "#0d2e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6357",
    "data-name": "Path 6357",
    d: "M867.043,1164.39a.329.329,0,0,1-.311-.435c.029-.084,2.868-8.425,2.205-13.611s-4.948-11.8-4.992-11.871a.328.328,0,1,1,.549-.359c.18.276,4.412,6.809,5.094,12.146s-2.116,13.561-2.236,13.908A.328.328,0,0,1,867.043,1164.39Z",
    transform: "translate(-794.618 -1085.479)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6358",
    "data-name": "Path 6358",
    d: "M747.459,1186.576a.368.368,0,0,1-.054,0,.329.329,0,0,1-.27-.377l2.452-14.971a.328.328,0,1,1,.648.106l-2.452,14.972A.328.328,0,0,1,747.459,1186.576Z",
    transform: "translate(-716.171 -1107.638)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4699",
    "data-name": "Group 4699",
    transform: "translate(14.088 70.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6359",
    "data-name": "Path 6359",
    d: "M879.754,1200.405l21.576,17.5,2.715-13.5-11.161-11.1Z",
    transform: "translate(-819.362 -1193.31)",
    fill: "#f79f7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4698",
    "data-name": "Group 4698",
    transform: "translate(0 3.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6360",
    "data-name": "Path 6360",
    d: "M695.96,1219.978l2.028-16.226,15.092,4.535-2.275,15.508Z",
    transform: "translate(-695.88 -1203.752)",
    fill: "#f79f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6361",
    "data-name": "Path 6361",
    d: "M766.263,1261.405l-.515-3.4a5.156,5.156,0,0,0-3.462-4.118l-8.721-2.919-57.606-1.738c-4.178,22.348,46.8,9.941,54.944,7.824l13.885,5.523A1.087,1.087,0,0,0,766.263,1261.405Z",
    transform: "translate(-695.716 -1234.307)",
    fill: "#f79f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6362",
    "data-name": "Path 6362",
    d: "M721.274,1250.363H709.846a.328.328,0,0,1,0-.656h11.428a.328.328,0,0,1,0,.656Z",
    transform: "translate(-704.989 -1234.626)",
    fill: "#c05656"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4697",
    "data-name": "Group 4697",
    transform: "translate(61.192 18.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6363",
    "data-name": "Path 6363",
    d: "M890.878,1269.729a.332.332,0,0,1-.116-.021l-8.356-3.162a.328.328,0,0,1,.232-.614l8.356,3.162a.328.328,0,0,1-.116.635Z",
    transform: "translate(-882.193 -1264.235)",
    fill: "#c05656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6364",
    "data-name": "Path 6364",
    d: "M891.165,1264.349a.333.333,0,0,1-.116-.021l-7.636-2.889a.328.328,0,0,1,.232-.614l7.636,2.89a.328.328,0,0,1-.116.635Z",
    transform: "translate(-882.87 -1260.803)",
    fill: "#c05656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6365",
    "data-name": "Path 6365",
    d: "M891.372,1275.9a.332.332,0,0,1-.107-.018l-8.83-3.057a.328.328,0,0,1,.215-.62l8.83,3.057a.328.328,0,0,1-.107.638Z",
    transform: "translate(-882.207 -1268.45)",
    fill: "#c05656"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "plants",
    transform: "translate(285.179 125.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4705",
    "data-name": "Group 4705",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4704",
    "data-name": "Group 4704",
    transform: "translate(66.77 40.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6372",
    "data-name": "Path 6372",
    d: "M1701.172,1297.9s2.39-51.9,20.914-51.306,37.347,21.512,37.347,21.512l-34.658-3.884-11.353,33.678Z",
    transform: "translate(-1701.172 -1246.592)",
    fill: "#265761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6373",
    "data-name": "Path 6373",
    d: "M1719.853,1320.2c-.077-.186-.192-.468,11.725-37.318a5.635,5.635,0,0,1,6.781-3.713l27.124,7.1-.166.635-27.124-7.1a4.976,4.976,0,0,0-5.992,3.28c-7.259,22.447-11.641,36.277-11.72,37l-.264-.029Z",
    transform: "translate(-1713.714 -1268.358)",
    fill: "#5c8b7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6374",
    "data-name": "Path 6374",
    d: "M1646.844,1215.633l-2.815-37.493a7.079,7.079,0,0,0-.786-2.749l-26.746-51.1a.288.288,0,0,0-.53.212l13.571,54.094q.207.823.35,1.66l6.067,35.38Z",
    transform: "translate(-1577.151 -1124.139)",
    fill: "#5c8b7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6375",
    "data-name": "Path 6375",
    d: "M1648.044,1234.148a.328.328,0,0,1-.325-.288l-4.312-35.579a37.131,37.131,0,0,0-2.336-9.2l-14.376-36.3a.328.328,0,1,1,.61-.242l14.377,36.3a37.821,37.821,0,0,1,2.379,9.359l4.312,35.579a.328.328,0,0,1-.287.365Z",
    transform: "translate(-1584.347 -1143.083)",
    fill: "#265761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6376",
    "data-name": "Path 6376",
    d: "M1564.466,1338.236l-12.51-22.671a17.292,17.292,0,0,0-20.658-8.034l-33.6,11.315,34.7.757a7.88,7.88,0,0,1,5.556,2.468l15.649,16.576h12.261",
    transform: "translate(-1497.696 -1246.742)",
    fill: "#265761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6377",
    "data-name": "Path 6377",
    d: "M1580.344,1355.134l-16.275-18.158a16.5,16.5,0,0,0-14.114-5.378l-20.91,2.349-.073-.652,20.91-2.349a17.168,17.168,0,0,1,14.676,5.593l16.274,18.157Z",
    transform: "translate(-1518.709 -1263.011)",
    fill: "#5c8b7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4706",
    "data-name": "Group 4706",
    transform: "translate(49.137 90.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6378",
    "data-name": "Path 6378",
    d: "M1679.214,1464.276h-26.345l-5.432-63H1685.5Z",
    transform: "translate(-1647.438 -1401.276)",
    fill: "#b0b1b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6379",
    "data-name": "Path 6379",
    d: "M1705.435,1401.276v63h12.745l6.287-63Z",
    transform: "translate(-1686.403 -1401.276)",
    fill: "#babec8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4715",
    "data-name": "Group 4715",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4711",
    "data-name": "Group 4711",
    transform: "translate(0 44.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4707",
    "data-name": "Group 4707",
    transform: "translate(62.982 45.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6380",
    "data-name": "Path 6380",
    d: "M670.351,1035.484l-4.29-16.525L648.4,1017.4s9.591,25.357,10.872,26.972c.286-1.439.722-4.7,1.71-5.8C663.445,1035.85,666.522,1035.813,670.351,1035.484Z",
    transform: "translate(-648.402 -1017.403)",
    fill: "#f79f7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4708",
    "data-name": "Group 4708",
    transform: "translate(43.381 213.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6381",
    "data-name": "Path 6381",
    d: "M597.952,1531.176l.277,15.2h12.988l-.094-15.2Z",
    transform: "translate(-594.906 -1531.176)",
    fill: "#f79f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6382",
    "data-name": "Path 6382",
    d: "M593.118,1561.623a13.325,13.325,0,0,0,7.9-.851,4.975,4.975,0,0,1,4.5,0l14.345,7.394a3.808,3.808,0,0,1,2,3.4v1.98H591.278a2.737,2.737,0,0,1-2.563-3.3l1.084-6.111A2.953,2.953,0,0,1,593.118,1561.623Z",
    transform: "translate(-588.669 -1550.7)",
    fill: "#30475e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4709",
    "data-name": "Group 4709",
    transform: "translate(8.024 216.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6383",
    "data-name": "Path 6383",
    d: "M489.267,1538.649l-1.026,13.742h12.988l1.209-13.742Z",
    transform: "translate(-485.839 -1538.649)",
    fill: "#f79f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6384",
    "data-name": "Path 6384",
    d: "M485.37,1561.623a13.325,13.325,0,0,0,7.9-.851,4.975,4.975,0,0,1,4.5,0l14.345,7.394a3.809,3.809,0,0,1,2,3.4v1.98H483.53a2.737,2.737,0,0,1-2.563-3.3l1.085-6.111A2.953,2.953,0,0,1,485.37,1561.623Z",
    transform: "translate(-480.921 -1553.152)",
    fill: "#30475e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6385",
    "data-name": "Path 6385",
    d: "M465.815,1082.728l4.957,151.016h16.974a2.341,2.341,0,0,0,2.336-2.2l7.126-118.3,7.943,120.5H523.39a2.341,2.341,0,0,0,2.34-2.371l-1.9-148.767-22.044,1.105-29.4.611",
    transform: "translate(-462.748 -1015.968)",
    fill: "#30475e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6386",
    "data-name": "Path 6386",
    d: "M456.874,954.717l12.01-37.424-11.363-4.751a1.708,1.708,0,0,1-.888-2.3c3.538-7.528,20.15-38.211,52.191-29,32.554,9.362,33.458,35.411,33.049,42.683a2.244,2.244,0,0,1-2.005,2.1L522.9,927.837l-3.042,33.227a8.683,8.683,0,0,1-4.622,6.91C506,972.8,482.927,981.436,459.6,963.536A8.025,8.025,0,0,1,456.874,954.717Z",
    transform: "translate(-456.469 -879.534)",
    fill: "#5c8b7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6387",
    "data-name": "Path 6387",
    d: "M658.171,1002.72h0a.325.325,0,0,0,.385-.253l2.4-11.558a.325.325,0,0,0-.252-.385h0a.326.326,0,0,0-.385.253l-2.4,11.558A.326.326,0,0,0,658.171,1002.72Z",
    transform: "translate(-591.81 -954.098)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6388",
    "data-name": "Path 6388",
    d: "M524.237,976.8a.325.325,0,0,0,.358-.174l7.523-15.116a.326.326,0,1,0-.583-.29l-7.523,15.116a.326.326,0,0,0,.146.437A.333.333,0,0,0,524.237,976.8Z",
    transform: "translate(-501.825 -934.292)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4710",
    "data-name": "Group 4710",
    transform: "translate(2.898 34.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6389",
    "data-name": "Path 6389",
    d: "M533.712,1041.059l-9.1-6.715,0,0a4.151,4.151,0,0,0-2.014-1.53l-7.994-2.838-.067.051-30.546-20.207a4.22,4.22,0,0,1-1.818-4.307l2.226-12.007a1.327,1.327,0,0,0-.773-1.458l-15.988-6.99s-5.472,27.269.336,31.936c4.958,3.984,32.41,16.812,40.334,20.479h0l5.277,5.965a4.394,4.394,0,0,0,2.294.885l2.542.217a4.4,4.4,0,0,0,4.083-2.023l2.227-3.508c.007-.011.012-.022.018-.033l7.721,3.774a.955.955,0,0,0,.884.032l.2-.1A.955.955,0,0,0,533.712,1041.059Z",
    transform: "translate(-465.302 -985.062)",
    fill: "#f79f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6390",
    "data-name": "Path 6390",
    d: "M493.476,1054.269a.328.328,0,0,1-.046-.653c7.767-1.118,7.78-1.072,7.889-.708a.329.329,0,0,1-.406.41h-.01c-.577,0-4.789.575-7.38.948A.282.282,0,0,1,493.476,1054.269Zm7.215-1.171a.331.331,0,0,0,.043.09A.326.326,0,0,1,500.691,1053.1Zm0,0h0Z",
    transform: "translate(-484.01 -1030.489)",
    fill: "#c05656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6391",
    "data-name": "Path 6391",
    d: "M643.159,1144.683a.329.329,0,0,1-.281-.158l-1.286-2.123a.328.328,0,0,1,.562-.34l1.286,2.122a.328.328,0,0,1-.281.5Z",
    transform: "translate(-583.711 -1090.437)",
    fill: "#c05656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6392",
    "data-name": "Path 6392",
    d: "M638.472,1151.151a.328.328,0,0,1-.281-.158l-1.286-2.123a.328.328,0,0,1,.561-.34l1.286,2.122a.329.329,0,0,1-.281.5Z",
    transform: "translate(-580.562 -1094.782)",
    fill: "#c05656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6393",
    "data-name": "Path 6393",
    d: "M633.242,1157.619a.329.329,0,0,1-.281-.158l-1.286-2.122a.328.328,0,1,1,.561-.34l1.286,2.122a.328.328,0,0,1-.28.5Z",
    transform: "translate(-577.048 -1099.128)",
    fill: "#c05656"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4714",
    "data-name": "Group 4714",
    transform: "translate(17.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6394",
    "data-name": "Path 6394",
    d: "M611.141,804.558s3.287-4.037,4.118-12.1-20.153-12.152-20.153-12.152-19.711,15.966-3.847,29.012Z",
    transform: "translate(-560.645 -768.092)",
    fill: "#303c60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4713",
    "data-name": "Group 4713",
    transform: "translate(27.829 25.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4712",
    "data-name": "Group 4712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6395",
    "data-name": "Path 6395",
    d: "M599.684,823.428c.918-.46,2.315,1.042,2.315,1.042.151.449.87,2.835,1.216,3.987a.189.189,0,0,0,.363,0l1.238-4.423a4.642,4.642,0,0,1,2.519-2.872l.043-.02a3.453,3.453,0,0,1,3.1.1,26.477,26.477,0,0,0,9.227,2.654l-1.832,11.766a4.7,4.7,0,0,1-5.37,3.923l-1.869-.291-.018,0a1.8,1.8,0,0,0-2.052,1.5l-.868,5.573a4.256,4.256,0,0,1-5,3.785c-2.822-.3-7.692-3.68-7.26-6.453l4.981-14.8a2.944,2.944,0,0,1-2.163-3.3A2.676,2.676,0,0,1,599.684,823.428Z",
    transform: "translate(-595.413 -820.819)",
    fill: "#f79f7b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6396",
    "data-name": "Path 6396",
    d: "M626.5,866.32a9.1,9.1,0,0,0,3.9,3.37,1.8,1.8,0,0,0-1.558,1.505l-.061.392a6.646,6.646,0,0,1-3.18-4.952A.488.488,0,0,1,626.5,866.32Z",
    transform: "translate(-615.688 -851.23)",
    fill: "#c05656"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6397",
    "data-name": "Path 6397",
    d: "M608.922,833.427a.543.543,0,0,0,.518-.892l-1.624-1.828a.543.543,0,1,0-.812.721l1.623,1.828A.536.536,0,0,0,608.922,833.427Z",
    transform: "translate(-575.279 -801.831)",
    fill: "#c05656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6398",
    "data-name": "Path 6398",
    d: "M548.751,755.894s4.554-14.972-11.923-12.544-26.222,28.885-26.222,28.885h0a22.647,22.647,0,0,0,23.941-9.1c2.6-3.714,5.963-6.391,9.925-5Z",
    transform: "translate(-510.606 -743.084)",
    fill: "#303c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6399",
    "data-name": "Path 6399",
    d: "M605.276,782.98s4.744-3.575,7.343-1.976l.41.671-7.584,1.964Z",
    transform: "translate(-574.21 -768.284)",
    fill: "#f5d9d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(127.052 150.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4732",
    "data-name": "Group 4732",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4731",
    "data-name": "Group 4731",
    transform: "translate(29.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6420",
    "data-name": "Path 6420",
    d: "M980.657,1232.982H934.7l5.741-28.553a2.485,2.485,0,0,1,2.436-2h40.893a2.485,2.485,0,0,1,2.437,2.975Z",
    transform: "translate(-934.695 -1202.434)",
    fill: "#e8e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6421",
    "data-name": "Path 6421",
    d: "M1009.171,1239.736a5.8,5.8,0,0,1-5.423,4.515,3.587,3.587,0,0,1-3.607-4.515,5.8,5.8,0,0,1,5.423-4.515A3.588,3.588,0,0,1,1009.171,1239.736Z",
    transform: "translate(-978.604 -1224.462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6422",
    "data-name": "Path 6422",
    d: "M873.526,1285.108l-29.876-3.971,30.9-1.117Z",
    transform: "translate(-843.649 -1254.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6423",
    "data-name": "Path 6423",
    d: "M843.649,1283.424l29.876,3.971-1.149.843-27.781-3.815Z",
    transform: "translate(-843.649 -1256.847)",
    fill: "#e8e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6424",
    "data-name": "Path 6424",
    d: "M931.193,1296.368l46.071.053,1.041-.9H932.342Z",
    transform: "translate(-902.466 -1264.978)",
    fill: "#4d5463"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAvailable);
export default __webpack_public_path__ + "static/media/no-data-available.c51824c28b06531cd0176540214e0c71.svg";
export { ForwardRef as ReactComponent };